import { render, staticRenderFns } from "./MbxData.vue?vue&type=template&id=8ef9337c"
import script from "./MbxData.vue?vue&type=script&lang=js"
export * from "./MbxData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports